import React from "react";
import { Box } from "@mui/material";

const PageContent = ({ children, sx, width = { xs: "100%", sm: "95%", md: "90%", lg: "85%" } }) => (
  <Box
    sx={{
      pt: { xs: 2, md: 3 },
      pb: { xs: 2, md: 3 },
      px: { xs: 1.5, sm: 2, md: 0 },
      display: "flex",
      justifyContent: "center",
      ...sx,
    }}
  >
    <Box sx={{ width, maxWidth: "100%" }}>{children}</Box>
  </Box>
);

export default PageContent;
